export const sheetActionType = {
  addSectionsToSheet: "AddSectionsToSheet",
  addSheetDetails: "AddSheetDetails",
  editSheetDetails: "EditSheetDetails",
  addSheetEditDetails: "AddSheetEditDetails",
};
